import { render, staticRenderFns } from "./wordChart.vue?vue&type=template&id=711e9fc6&"
import script from "./wordChart.vue?vue&type=script&lang=js&"
export * from "./wordChart.vue?vue&type=script&lang=js&"
import style0 from "./wordChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports